<template>
  <!--<div class="fullscreen" :style="backgroundColorStyle">-->
  <div
    id="background-container"
    class="fullscreen"
    :style="backgroundColourStyle"
  >
    <ProgressIndicator
      :progress="progress"
      style="position: absolute; bottom: 6vh"
    />
    <div v-if="showMoveNameAnimate" id="move-name" class="move-name">
      <!--{{ moveNameAnimate }} -->
      <!--<span class="letter">I</span>
      <span class="letter">n</span>
      <span class="letter">f</span>
      <span class="letter">l</span>
      <span class="letter">a</span>
      <span class="letter">t</span>
      <span class="letter">i</span>
      <span class="letter">o</span>
      <span class="letter">n</span>-->
    </div>

    <slot></slot>
  </div>
</template>

<script>
import interpolate from 'color-interpolate'
import ProgressIndicator from '@/components/ProgressIndicator.vue'

import gsap from 'gsap'

export default {
  name: 'Background',
  components: { ProgressIndicator },
  /*props: {
    progress: {
      type: Number,
      default: 50,
    },
  },*/
  data() {
    return {
      bgColormap: interpolate(['#003745', '#CDF4DD']),
      showMoveNameAnimate: false,
    }
  },
  computed: {
    progressWidthStyle() {
      return {
        width: `${this.progress >= 100 ? 110 : this.progress + 5}%`,
      }
    },
    backgroundColorStyle() {
      return {
        backgroundColor: this.bgColormap(this.progress / 1000),
      }
    },
    progress() {
      return Math.min(
        Math.max(0, Math.floor(this.$store.getters.unlockProgress)),
        100
      )
    },
    backgroundColour() {
      const colours = {
        green: '#002228',
        red: '#541218',
        blue: '#0F1D57',
      }
      //return Object.values(colours)[this.$store.getters.level]
      return Object.values(colours)[0]
    },
    backgroundColourStyle() {
      return {
        backgroundColor: this.backgroundColour,
      }
    },
    moveNameAnimate() {
      return this.$store.getters.moveNameAnimate
    },
  },
  methods: {
    addSpannedMovename(moveName) {
      //debugger
      const moveArray = Array.from(moveName)
      let charArray = []

      let lastChar = moveArray[0]

      for (let i = 1; i < moveArray.length; i++) {
        if (moveArray[i] == ' ') {
          charArray.push(lastChar + '&nbsp;')
          lastChar = ''
        } else {
          charArray.push(lastChar)
          lastChar = moveArray[i]
        }
      }
      charArray.push(lastChar)

      charArray = charArray.filter((x) => x != '')

      const elem = document.getElementById('move-name')

      charArray.forEach((c) => {
        const span = document.createElement('span')
        span.innerHTML = c
        span.classList.add('letter')
        elem.appendChild(span)
      })

      console.log(charArray)
    },
  },
  watch: {
    moveNameAnimate(new_val, old_val) {
      if (!(new_val === undefined) && old_val === undefined) {
        this.showMoveNameAnimate = true

        this.$nextTick(() => {
          //const tl = gsap.timeline({ repeat: 0 })
          this.addSpannedMovename(this.moveNameAnimate)

          gsap.from('.letter', {
            opacity: 0,
            y: -15,
            duration: 0.5,
            ease: 'bounce',
            /*repeat: 1,
            yoyo: true,*/
            onComplete: () => {
              this.showMoveNameAnimate = false
              this.$store.commit('SET_MOVE_NAME_ANIMATE', undefined)
            },
            stagger: {
              amount: 0.25,
              repeat: 1,
              yoyo: true,
              onRepeat: () => {
                console.log('repeat stagger')
              },
              onComplete: () => {
                console.log('completed stagger')
              },
            },
          })

          /*tl.to(
            '.letter',
            {
              opacity: 0,
              y: 15,
              ease: 'elastic.in',
              duration: 1,
              onComplete: () => {
                this.showMoveNameAnimate = false
                this.$store.commit('SET_MOVE_NAME_ANIMATE', undefined)
              },
              stagger: {
                amount: 0.3,
              },
            },
            '<+=1'
          )*/

          /*tl.to('#move-name', {
            opacity: 0,
            scale: 1.5,
            duration: 0.5,
            onComplete: () => {
              this.showMoveNameAnimate = false
              this.$store.commit('SET_MOVE_NAME_ANIMATE', undefined)
            },
          })*/

          /*tl.to(
            '.letter',
            {
              opacity: 0,
              y: -25,
              ease: 'elastic.out',
              duration: 2,
              onComplete: () => {
                this.showMoveNameAnimate = false
                this.$store.commit('SET_MOVE_NAME_ANIMATE', undefined)
              },
              stagger: {
                amount: 0.5,
              },
            },
            '>'
          )*/

          /*tl.to('#move-name', {
            y: '-5rem',
            opacity: 0,
            scale: 1.5,
            duration: 0.75,
            onComplete: () => {
              this.showMoveNameAnimate = false
              this.$store.commit('SET_MOVE_NAME_ANIMATE', undefined)
            },
          })*/

          /*tl.from('#move-name', {
            scale: 2,
            opacity: 0,
            duration: 0.2,
          })
          tl.to(
            '#move-name',
            {
              //y: '-1rem',
              opacity: 0,
              scale: 2,
              duration: 0.2,
              onComplete: () => {
                this.showMoveNameAnimate = false
                this.$store.commit('SET_MOVE_NAME_ANIMATE', undefined)
              },
            },
            '+=0.1'
          )*/
        })
      }
    },
  },
  /*watch: {
    backgroundColour(new_val) {
      console.log('backgroundColor changed')
      this.$nextTick(() => {
        console.log('running animation')
        const tl = gsap.timeline()
        tl.to(document.getElementById('background-container'), {
          backgroundColor: 'white',
          duration: 0.5,
        })
        tl.to(document.getElementById('background-container'), {
          backgroundColor: new_val,
          duration: 0.5,
        })
      })
    },
  },*/
}
</script>

<style scoped>
.fullscreen {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  /*background-color: #003745;*/
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 1s;
}

.move-name {
  position: absolute;
  top: 5rem;
  /*color: #cdf4dd;*/
  color: #468b18;
  font-family: 'Montserrat', sans-serif;
  font-size: 2rem;
  font-weight: 600;
}

.move-name > * + * {
  margin-left: 0.2rem;
}
/*.outer-progress-container {
  position: absolute;
  top: 12vh;
  overflow: hidden;
}

.progress-container {
  width: calc(clamp(2rem, 17.6vmin, 4.5rem) * 3.5);
  height: calc(clamp(2rem, 17.6vmin, 4.5rem) * 0.3);
  border: solid 2px rgba(205, 244, 221, 0.5);
  border-radius: 5px;
  transition: border-color 0.3s;
}

.progress-container-red {
  border-color: rgba(255, 54, 51, 0.5);
}

.progress-label {
  text-align: center;
  margin-bottom: 2px;
  font-family: 'Montserrat', sans-serif;
  color: rgb(205, 244, 221, 0.5);
}

.inner-progress {
  height: 100%;
  margin-left: -5%;
  background-color: rgba(205, 244, 221, 0.2);
  transition: background-color 0.3;
}

.inner-progress-red {
  background-color: rgba(255, 54, 51, 0.2);
}

.fade-in-enter {
  opacity: 0;
}

.fade-in-enter-active {
  transition: opacity 0.3s;
}

.fade-in-leave-to {
  opacity: 0;
}

.fade-in-leave-active {
  transition: opacity 0.3s;
}*/
</style>

<style>
.letter {
  display: inline-block;
}
</style>
